import {Injectable} from '@angular/core';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {SourceResolverService} from '../search-input-source-resolver/source-resolver.service';
import {ElasticValidator, ElasticValidatorFactory} from 'asax-elastic';

export interface TargetListLineResolved {
  readonly text: string;
  readonly isValid?: boolean;
  readonly raDecRadius?: string;
  readonly lineNumber?: number;
}

@Injectable({providedIn: 'root'})
export class TargetListService {
  private raDecValidator: ElasticValidator;

  constructor(private readonly sourceResolverService: SourceResolverService,
              private readonly elasticValidatorFactory: ElasticValidatorFactory) {
    this.raDecValidator = this.elasticValidatorFactory.getElasticValidator('ra-dec');
  }

  resolveTargetListString(targetListString: string): Observable<any> {
    const lines = targetListString?.split(/[\r\n]+/g);
    const observables = lines?.filter(line => line?.length > 0).map(line => this.resolveLine(line));

    return forkJoin(observables);
  }

  private resolveLine(line: string): Observable<TargetListLineResolved> {
    const {isInvalid} = this.raDecValidator.validate(line);

    if (isInvalid === false) {
      return of({text: line, isValid: true, raDecRadius: line});
    } else {
      return this.sourceResolverService.resolveSource(line).pipe(
        map(sourceResolved => ({
          text: line,
          isValid: sourceResolved.oName ? true : false,
          raDecRadius: sourceResolved.oName ? `${sourceResolved.jRaDeg} ${sourceResolved.jDecDeg}, ${sourceResolved.radius}` : undefined
        })),
        catchError(error => of({text: line, isValid: false, raDecRadius: undefined}))
      );
    }
  }
}
